import { TweenLite } from 'gsap/TweenLite';
import { CSSPlugin, ScrollToPlugin } from 'gsap/all';
import { Datalayers } from './Datalayers';

/* eslint-disable */
// let this be please
const plugins = [CSSPlugin, ScrollToPlugin];
/* eslint-enable */

const SELECTORS = {
    TOGGLE: '.js-collapsible-content-toggle',
    CONTENT: '.js-collapsible-content',
};

const CLASSES = {
    TOGGLE: 'collapsible-toggle--active',
    CONTENT: 'collapsible--open',
};

class CollapseToggle {
    constructor(toggle, target = false) {
        this.toggle = toggle;
        this.target = target || document.querySelector(this.toggle.dataset.target);
        this.isOpen = this.toggle.classList.contains(CLASSES.TOGGLE);
        this.closeOthers = this.toggle.getAttribute('data-close-other') !== null;
        this.shouldCloseOthersWithinParent = this.toggle.getAttribute('data-close-others-parent') !== null;
        this.closeOthersParent = this.closeOthers
            ? document.querySelector(`${this.toggle.dataset.closeOthersParent}`) : null;
        this.datalayers = new Datalayers();

        this.handleClick.bind(this);
        this.showContent.bind(this);
        this.hideContent.bind(this);
    }

    init() {
        this.handleClick();
    }

    handleClick() {
        this.toggle.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.isOpen) {
                this.hideContent();
            } else {
                this.showContent();
            }
        });
    }

    showContent() {
        if (this.closeOthers) {
            const parentContainer = this.shouldCloseOthersWithinParent
                ? this.closeOthersParent : document;

            const activeToggles = [...parentContainer.querySelectorAll(`.${CLASSES.TOGGLE}`)];
            const openCollapsedContent = [...parentContainer.querySelectorAll(`.${CLASSES.CONTENT}`)];

            if (activeToggles) {
                activeToggles.forEach((toggle) => {
                    toggle.classList.remove(CLASSES.TOGGLE);
                });
            }

            if (openCollapsedContent) {
                openCollapsedContent.forEach((content) => {
                    content.classList.remove(CLASSES.CONTENT);
                    TweenLite.to(content, 0.3, {
                        height: 0,
                    });
                });
            }
        }

        this.toggle.classList.add(CLASSES.TOGGLE);
        this.target.classList.add(CLASSES.CONTENT);
        this.toggle.setAttribute("aria-expanded", "true");
        this.datalayers.pushData({
            event: 'event',
            eventcategory: 'contentExtension',
            eventAction: 'click',
            content: this.toggle.textContent.trim(),
        });

        TweenLite.to(this.target, 0.3, {
            height: 'auto',
        });
        if (!this.isOpen) {
            TweenLite.from(this.target, 0.3, {
                height: 0,
            });
        }

        this.isOpen = !this.isOpen;
    }

    hideContent() {
        this.target.classList.remove(CLASSES.CONTENT);
        this.toggle.classList.remove(CLASSES.TOGGLE);
        this.toggle.setAttribute("aria-expanded", "false");

        TweenLite.to(this.target, 0.3, {
            height: 0,
        });

        this.isOpen = !this.isOpen;
    }
}

function initCollapse() {
    const TOGGLES = [...document.querySelectorAll(SELECTORS.TOGGLE)];

    if (TOGGLES) {
        TOGGLES.forEach((TOGGLE) => {
            const collapseToggle = new CollapseToggle(TOGGLE);
            collapseToggle.init();
        });
    }
}

export { initCollapse, CollapseToggle };
